
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/claim-eth",
      function () {
        return require("private-next-pages/claim-eth.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/claim-eth"])
      });
    }
  